import { useThumbFirst } from "./thumb-first";

export interface ThumbImageProps {
  /** The lighter picture: a 512 px thumbnail; none, or not made yet, shows `full`. */
  thumb: string | null | undefined;
  full: string;
  alt: string;
  className?: string | undefined;
  /** The full picture failed too: the list reads its signed URLs again. */
  onLost?: (() => void) | undefined;
  /**
   * The picture's width and height where known (a product image's, spec ui-perf/product-images):
   * on the `<img>`, its box keeps the picture's shape before it loads, so a list's pictures below
   * the view are not all inside it at first, and lazy loading waits for them.
   */
  width?: number | null | undefined;
  height?: number | null | undefined;
}

/**
 * A tile's `<img>`, its thumbnail first and the full picture when that fails (`useThumbFirst`),
 * lazy and decoded off the main thread: a list's pictures load as they near the view, not all
 * at once (issue 828, item 12).
 */
export function ThumbImage({ thumb, full, alt, className, onLost, width, height }: ThumbImageProps) {
  const picture = useThumbFirst(thumb, full, onLost);
  const size = width != null && height != null && width > 0 && height > 0 ? { width, height } : {};
  return (
    <img
      src={picture.src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={picture.onError}
      {...size}
    />
  );
}
